module.exports = __webpack_public_path__ + "img/wechat_group_deco.d676df6a.png";